import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import {  AngularFireDatabase,AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { Invites } from '../models/invites';

@Injectable()
export class AttendeesService {

  constructor(private db: AngularFireDatabase,private utilityService:UtilityService) { }

  getAttendeesList(id: string):Observable<any>{
    if(this.utilityService.isLogged()){
      let data :AngularFireObject<any> = this.db.object(Constants.EVENT_USER_DATA_URL+'/'+id+Constants.INVITES_URL);
      return  data.valueChanges();
    }
    return null;
  }

  addInvites(eventId: string, invites: Invites):Promise<any> {
    let email = invites.email.replace(/\./g,',');
    let obj = new Invites();
    obj.isAttending = invites.isAttending;
    obj.reason = invites.reason;
    return this.db.object(Constants.EVENT_USER_DATA_URL+'/'+eventId+Constants.INVITES_URL+'/'+email).set(obj);
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/attendees.service.ts